import { render, staticRenderFns } from "./ReplyForm.vue?vue&type=template&id=45c47a2a"
import script from "./ReplyForm.vue?vue&type=script&lang=js"
export * from "./ReplyForm.vue?vue&type=script&lang=js"
import style0 from "./ReplyForm.vue?vue&type=style&index=0&id=45c47a2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports